<ion-header>
  <ion-toolbar
    [class.modal-toolbar]="isInModal && platform !== platformRef.desktop"
    [class.desktop-toolbar]="platform === platformRef.desktop"
  >
    <ion-back-button
      *ngIf="platform !== platformRef.desktop && !isInModal"
      slot="start"
      text=""
      defaultHref="/touch/lists"
      icon="chevron-back-outline"
    ></ion-back-button>
    <ion-icon
      *ngIf="platform !== platformRef.desktop && isInModal"
      data-cy="back-icon"
      (click)="closeIconClick()"
      name="chevron-back-outline"
      slot="start"
      class="touch-icon"
    ></ion-icon>
    <ion-label>{{ title | translate }}</ion-label>

    <ion-icon
      *ngIf="platform === platformRef.desktop"
      data-cy="close-icon"
      (click)="closeIconClick()"
      name="close-outline"
      slot="end"
      class="desktop-icon"
    ></ion-icon> </ion-toolbar
></ion-header>
